<template>
  <v-row>
    <v-col cols="8">
      <v-stepper v-model="currentStep" show-actions class="elevation-0">
        <v-stepper-header class="elevation-0">
          <v-stepper-item
            :value="1"
            :color="!!newItem.type ? 'success' : 'primary'"
            :complete="!!newItem.type"
          >
            Ad Type
          </v-stepper-item>

          <v-divider />
          <v-stepper-item :value="2" :editable="!!newItem.type">
            Budget & Settings
          </v-stepper-item>
          <v-divider />

          <v-stepper-item :value="3" :editable="!!newItem.type">
            Goal
          </v-stepper-item>
          <v-divider />

          <v-stepper-item :value="4" :editable="!!newItem.type">
            Targeting
          </v-stepper-item>
          <v-divider />

          <v-stepper-item :value="5" :editable="!!newItem.type">
            Creatives
          </v-stepper-item>
        </v-stepper-header>

        <v-stepper-window>
          <v-stepper-window-item :value="1">
            <AdTypeSelector
              ref="typeSelector"
              v-model="newItem.type"
              @next="next"
            />
          </v-stepper-window-item>

          <v-stepper-window-item :value="2">
            <v-form
              ref="budgetForm"
              v-model="budgetForm"
              validate-on="input"
              fast-fail
              @update:model-value="
                (v) => (v === null ? (budgetForm = true) : (budgetForm = v))
              "
            >
              <v-row class="pa-2">
                <v-col cols="12" md="6">
                  <CampaignRunSettings v-model="newItem" @next="next" />
                </v-col>
                <v-col cols="12" md="6">
                  <CampaignBudget v-model="newItem" @next="next" />
                </v-col>
              </v-row>
            </v-form>
          </v-stepper-window-item>

          <v-stepper-window-item :value="3">
            <v-form
              ref="kpiForm"
              v-model="kpiForm"
              validate-on="input"
              fast-fail
              @update:model-value="
                (v) => (v === null ? (kpiForm = true) : (kpiForm = v))
              "
            >
              <CampaignGoal
                v-model="newItem"
                @next="next"
              />
            </v-form>
          </v-stepper-window-item>

          <v-stepper-window-item :value="4">
            <v-form
              ref="targetingForm"
              v-model="targetingForm"
              validate-on="input"
              fast-fail
              @update:model-value="
                (v) =>
                  v === null ? (targetingForm = true) : (targetingForm = v)
              "
            >
              <CampaignTargeting v-model="newItem" @next="next" />
            </v-form>
          </v-stepper-window-item>

          <v-stepper-window-item :value="5">
            <v-form
              ref="creativeForm"
              v-model="creativeForm"
              validate-on="input"
              fast-fail
              @update:model-value="
                (v) => (v === null ? (creativeForm = true) : (creativeForm = v))
              "
            >
              <CampaignCreativeEditor v-model="newItem" @next="next" />
            </v-form>
          </v-stepper-window-item>
        </v-stepper-window>
        <v-stepper-actions
          :disabled="disabled"
          @click:next="next"
          @click:prev="prev"
        >
          <template #next>
            <v-btn
              :disabled="!isStepValid(currentStep)"
              @click.prevent.stop="next"
              color="primary"
            >
              <span
                v-if="currentStep === 5"
                class="d-flex align-center justify-center"
              >
                Submit
              </span>
              <span v-else> Next </span>
            </v-btn>
          </template>
        </v-stepper-actions>
      </v-stepper>
    </v-col>
    <v-col cols="4">
      <CampaignCreationPreview v-model="newItem" />
    </v-col>
  </v-row>
</template>
    
    
<script>
import AdTypeSelector from "../../molecules/adType/AdTypeSelector.vue";
import CampaignCreationPreview from "./CampaignCreationPreview.vue";
import CampaignTargeting from "./CampaignTargeting.vue";
import CampaignBudget from "@/components/molecules/campaign/CampaignBudget.vue";
import CampaignRunSettings from "@/components/molecules/campaign/CampaignRunSettings.vue";
import CampaignCreativeEditor from "./CampaignCreativeEditor.vue";
import CampaignGoal from "@/components/molecules/campaign/CampaignGoal.vue";

export default {
  components: {
    AdTypeSelector,
    CampaignTargeting,
    CampaignCreationPreview,
    CampaignGoal,
    CampaignBudget,
    CampaignRunSettings,
    CampaignCreativeEditor,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    created: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["submit"],
  data() {
    return {
      currentStep: 1,

      kpiForm: true,
      budgetForm: true,
      settingsForm: true,
      targetingForm: true,
      creativeForm: true,

      newItem: {
        name: null,
        stats: null,
        type: null,
        goal: null,
        budget: null,
        targeting: null,
        creatives: [],
        risk: null,
        predictionResult:null
      },
    };
  },

  computed: {
    disabled() {
      return this.currentStep === 1
        ? "prev"
        : this.currentStep === 3
        ? "next"
        : undefined;
    },
  },
  // watch: {
  //   "newItem.targeting": {
  //     handler() {
  //       this.$refs.creativeForm.reset();
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    isStepValid(step) {
      switch (step) {
        case 1:
          return !!this.newItem.type;

        case 2:
          return !!this.newItem.budget && !!this.budgetForm;

        case 3:
          return !!this.newItem.goal && !!this.kpiForm;

        case 4:
          return !!this.newItem.targeting && !!this.targetingForm;

        case 5:
          return !!this.newItem.creatives && !!this.creativeForm;

        default:
          return true;
      }
    },
    prev() {
      this.currentStep--;
    },
    async next() {
      switch (this.currentStep) {
        case 1:
          break;
        case 2:
          await this.$refs.budgetForm.validate();
          break;
        case 3:
          await this.$refs.kpiForm.validate();
          break;
        case 4:
          await this.$refs.targetingForm.validate();
          break;
        case 5:
          await this.$refs.creativeForm.validate();
          break;
      }

      if (this.isStepValid(this.currentStep) && this.currentStep < 5)
        this.currentStep++;
      else if (this.isStepValid(this.currentStep) && this.currentStep === 5) {
        console.log("submit");
        this.$emit("submit", this.newItem);
      }
    },
    reset() {
      this.currentStep = 1;
      this.newItem = {
        type: null,
        name: null,
        description: null,
      };
    },
  },
};
</script>